import React, { useEffect } from "react";
import "./GameDevelopment.css";
import appImg from "../../assets/images/GameD.png";

const GameDevelopment = () => {
  useEffect(() => {
    const sections = document.querySelectorAll(".reveal-app");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-app");
          }
        });
      },
      { threshold: 0.2 }
    );

    sections.forEach((sec) => observer.observe(sec));
  }, []);

  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="app-hero-section reveal-app">
        <div className="app-hero-container">
          {/* LEFT TEXT */}
          <div className="app-hero-text reveal-app">
            <h1>Game Development</h1>

            <p>
            Powering the Future of Gaming
As the global gaming industry continues to thrive, we're excited to bring our passion for storytelling, technology, and innovation into the world of game development. At NMD INFO-TECH SERVICES, we specialize in crafting immersive and engaging gaming experiences that not only entertain but also connect with players on a deeper level.
            </p>

            <p>
            From concept to launch, we blend creativity with cutting-edge technology to deliver games that stand out in a competitive market. Whether it's mobile, web, or cross-platform gaming, our goal is to help brands create experiences that players remember — and return to.
            </p>

            <p>Let's create the next big game, together.</p>

            <button className="app-hero-btn">Get Started</button>
          </div>

          {/* RIGHT IMAGE */}
          <div className="app-hero-image reveal-app">
            <img src={appImg} alt="Game Development" />
          </div>
        </div>
      </section>

      {/* ================= SECOND FORM SECTION ============================================== */}
      <section className="app-second-section reveal-app">
  <div className="app-second-container">
    {/* LEFT FORM BOX */}
    <div className="app-form-box reveal-app">
      <h2>Get an Appointment</h2>

      <form
        action="https://api.web3forms.com/submit"
        method="POST"
      >
        {/* REQUIRED: WEB3FORMS ACCESS KEY */}
        <input
          type="hidden"
          name="access_key"
          value="157f5dfc-898c-4749-aab8-a80e612db795"
        />

        <input type="text" name="name" placeholder="Name *" required />
        <input type="email" name="email" placeholder="Email *" required />
        <textarea name="message" placeholder="Message Here" rows="5"></textarea>

        <button type="submit" className="app-send-btn">Send</button>
      </form>
    </div>

    {/* RIGHT TEXT CONTENT */}
    <div className="app-second-text reveal-app">
      <h1>
        Why Game Development? <br /> Because the World is Playing Like Never Before.
      </h1>

      <p>
        Gaming has transformed from a niche hobby into a global, multi-billion-dollar industry — one that brings together people of all ages, backgrounds, and interests. From casual mobile games to immersive console adventures, the demand for engaging and high-quality gaming experiences is growing by the day.
      </p>

      <p>
        At NMD Info-Tech Services, we recognize the limitless potential of this dynamic and ever-evolving market. Stepping into the world of game development isn’t just a strategic move — it’s a passionate leap into a space where creativity, technology, and storytelling come together to create magic.
      </p>

      <p>
        We’re here to design and develop games that captivate, entertain, and inspire. Whether it’s a quick-play mobile game or a complex, story-driven experience, our goal is to build games that players truly connect with.

        The future of entertainment is interactive — and we’re ready to lead the way.
      </p>
    </div>
  </div>
</section>

      
         {/* third section */}
     
      <section className="app-features-section reveal-app">
  <h2 className="app-feature-title">More Solutions We Offer</h2>
  
  <div className="scroll-line"></div>


  <div className="app-features-container">

   {/* CARD 1 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">📡</div>
      <h3>Custom App Development</h3>
      <p>Tailored to meet the specific needs of our clients, we develop native and cross-platform applications for iOS and Android platforms.</p>
    </div>

    <div className="card-back">
      <h3>Custom App Development</h3>
      <p>Tailored to meet the specific needs of our clients, we develop native and cross-platform applications for iOS and Android platforms.</p>
    </div>
  </div>
</div>


{/* CARD 2 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">🛠️</div>
      <h3>UI/UX Design</h3>
      <p>Our team of experienced designers ensures a visually appealing and user-friendly interface, enhancing the overall user experience.</p>
    </div>

    <div className="card-back">
      <h3>UI/UX Design</h3>
      <p>Our team of experienced designers ensures a visually appealing and user-friendly interface, enhancing the overall user experience.</p>
    </div>
  </div>
</div>


{/* CARD 3 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">⚡</div>
      <h3>Backend Development</h3>
      <p>We build robust and scalable backend systems, ensuring seamless integration of features and optimal performance.</p>
    </div>

    <div className="card-back">
      <h3>Backend Development</h3>
      <p>We build robust and scalable backend systems, ensuring seamless integration of features and optimal performance.</p>
    </div>
  </div>
</div>


{/* CARD 4 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">🔐</div>
      <h3>Quality Assurance</h3>
      <p>Rigorous testing procedures ensure flawless performance and excellent user experience.</p>
    </div>

    <div className="card-back">
      <h3>Quality Assurance</h3>
      <p>Rigorous testing procedures ensure flawless performance and excellent user experience.</p>
    </div>
  </div>
</div>


{/* CARD 5 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">☁️</div>
      <h3>Maintenance & Support</h3>
      <p>We offer ongoing support and maintenance to keep applications updated, secure, and aligned with evolving standards.</p>
    </div>

    <div className="card-back">
      <h3>Maintenance & Support</h3>
      <p>We offer ongoing support and maintenance to keep applications updated, secure, and aligned with evolving standards.</p>
    </div>
  </div>
</div>

  </div>
</section>

    </>
  );
};

export default GameDevelopment;
